import { PersonModel } from '@models/person.model';
import { DocumentTypeEnum } from '@models/document.model';

export class NotificationModel {
  id: string;
  isSeen: boolean;
  documentId: string;
  status: NotificationStatusEnum;
  personId: string;
  dateCreated: Date;
  accountId: number;
  person?: PersonModel;
  docType: DocumentTypeEnum;
  type: NotificationType;
  isReset?: boolean;

  static fromJSON(json: any): NotificationModel {
    return {
      id: json._id,
      isSeen: json.is_seen,
      documentId: json.document_id,
      status: json.status,
      personId: json.person_id,
      dateCreated: new Date(json.date_created),
      docType: json.doc_type,
      accountId: json.account_id,
      type: json.type,
      isReset: json.is_reset
    };
  }
}

export interface IDocumentNotificationResponse {
  notifications: NotificationModel[];
  count: number;
}

export interface INotificationCountResponse {
  count: number;
}

export enum NotificationStatusEnum {
  Approved = 'approved',
  NotVerified = 'not_verified',
  Declined = 'declined',
  Pending = 'pending',
  Expired = 'expired'
}

export enum NotificationType {
  DocumentVerification = 'document_verification',
  GoldVerification = 'gold_verification'
}
